'use strict';

var GetIntrinsic$1 = require('../GetIntrinsic.js');

var GetIntrinsic = GetIntrinsic$1;

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

var maxSafeInteger = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;

module.exports = maxSafeInteger;
